import {
  ComponentsOverrides,
  ComponentsProps,
  ComponentsVariants,
} from '@mui/material'
import { COLORS } from '~theme/colors'
import { typography } from '~theme/global'

export interface MuiTableCellData {
  defaultProps?: ComponentsProps['MuiTableCell']
  styleOverrides?: ComponentsOverrides['MuiTableCell']
  variants?: ComponentsVariants['MuiTableCell']
}

export const MuiTableCell: MuiTableCellData = {
  styleOverrides: {
    root: {
      ...typography.paragraph2,
      border: 'none',
      borderRight: `4px solid ${COLORS.primary.white}`,
      display: 'table-cell',
      height: '100%',
      verticalAlign: 'middle',
      paddingLeft: '12px',
      paddingRight: '12px',
      paddingTop: '10px',
      paddingBottom: '10px',
      '& a': {
        textDecoration: 'none',
      },
      '& a:hover': {
        textDecoration: 'underline',
      },
    },
    head: {
      ...typography.label,
    },
  },
}
